import Valuable from './base/valuable'

export default class Field extends Valuable {
  constructor (name, scope) {
    super()
    Object.assign(this, { name, scope })
  }

  match (raw) {
    if (raw.constructor !== String) return false
    if (raw.includes('.')) {
      const [scope, name] = raw.split('.')
      return (scope.toLowerCase() === this.scope) && (name.toLowerCase() === this.name.toLowerCase())
    }
    return raw.toLowerCase() === this.name.toLowerCase()
  }
}

Field.SCOPE = {
  GLOBAL: 'global',
  PLAYBOOK: 'playbook',
  CHARACTER: 'character'
}

Field.GlobalField = class GlobalField extends Field {
  constructor (name, value) {
    super(name, Field.SCOPE.GLOBAL)
    this.value = value
  }

  async getValue () {
    return this.value
  }
}

Field.PlaybookField = class PlaybookField extends Field {
  constructor (name, type) {
    super(name, Field.SCOPE.PLAYBOOK)
    Object.assign(this, { type })
  }

  async getValue ({ character, ui, type, context }) {
    const raw = character.playbook.fields[this.name]
    if (this.type.name === 'formula') {
      const value = await character.getRawValue({ raw, ui, type, context, fallback: raw })
      return value
    }
    return character.getValueFromType(raw, this.type)
  }
}

Field.CharacterField = class CharacterField extends Field {
  constructor (name) {
    super(name, Field.SCOPE.CHARACTER)
  }
}

Field.AutomaticField = class AutomaticField extends Field.CharacterField {
  constructor (name, calculationFormula) {
    super(name)
    this.calculationFormula = calculationFormula
  }

  async getValue ({ character, ui, type, context }) {
    return await character.get(this.calculationFormula, { ui, type, context })
  }
}

Field.ManualField = class ManualField extends Field.CharacterField {
  constructor (name, initializationFormula) {
    super(name)
    this.initializationFormula = initializationFormula
  }

  async getValue ({ character }) {
    return character.fields[this.name]
  }
}
